import { Navigate, Route, Routes } from 'react-router-dom';
import AboutPage from '../Portfolio/AboutPage';
import HomePage from '../Portfolio/HomePage';
import ProjectDetailPage from '../Portfolio/ProjectDetailPage';
import ProjectsPage from '../Portfolio/ProjectsPage';
import SiteLayout from '../Portfolio/SiteLayout';
import AdminConsole from '../Admin/AdminConsole';
import AdminLayout from '../Admin/AdminLayout';
import Edit from '../Admin/Edit';
import NewPost from '../Admin/NewPost/NewPost';
import ProjectEditor from '../Admin/Projects/ProjectEditor';
import ProjectManager from '../Admin/Projects/ProjectManager';
import ProfileEditor from '../Admin/Profile/ProfileEditor';
import AdminArticles from '../Admin/components/Content/Content';
import NotFoundPage from '../components/NotFoundPage';
import PageContainer from '../components/PageContainer/PageContainer';
import RequireAuth from '../components/RequireAuth';
import ForgetPassword from '../Login/ForgetPassword/ForgetPassword';
import Login from '../Login/Login';
import HeaderForLoginPage from '../Login/components/Header/Header';
import ResetPassword from '../Login/ResetPassword/ResetPassword';
import VerifySecurityQuestion from '../Login/VerifySecurityQuestion/VerifySecurityQuestion';
import PostContentLayout from './components/Content';
import DetailPost from './components/DetailPost/DetailPost';
import PostList from './components/PostList/PostList';

const Posts = () => (
    <Routes>
        <Route path="/" element={<SiteLayout />}>
            <Route index element={<HomePage />} />
            <Route path="projects" element={<ProjectsPage />} />
            <Route path="projects/:slug" element={<ProjectDetailPage />} />
            <Route path="about" element={<AboutPage />} />
            <Route element={<PostContentLayout />}>
                <Route path="writing" element={<PostList />} />
                <Route path="post/:id" element={<DetailPost />} />
            </Route>
            <Route path="*" element={<NotFoundPage />} />
        </Route>

        <Route path="/login/*" element={
            <PageContainer backgoundColor="#f5f6f8">
                <HeaderForLoginPage />
                <Routes>
                    <Route path="/" element={<Login />} />
                    <Route path="/forgetPassword" element={<ForgetPassword />} />
                    <Route path="/verifySecurityQuestion" element={<VerifySecurityQuestion />} />
                    <Route path="/resetPassword" element={<ResetPassword />} />
                </Routes>
            </PageContainer>
        } />

        <Route path="/admin" element={<RequireAuth><AdminLayout /></RequireAuth>}>
            <Route index element={<AdminConsole />} />
            <Route path="posts" element={<AdminArticles />} />
            <Route path="posts/new" element={<NewPost />} />
            <Route path="posts/:id/edit" element={<Edit />} />
            <Route path="projects" element={<ProjectManager />} />
            <Route path="projects/new" element={<ProjectEditor />} />
            <Route path="projects/:slug/edit" element={<ProjectEditor />} />
            <Route path="profile" element={<ProfileEditor />} />
            <Route path="console" element={<Navigate to="/admin" replace />} />
            <Route path="newPost" element={<Navigate to="/admin/posts/new" replace />} />
            <Route path="edit/:id" element={<Edit />} />
        </Route>

        <Route path="*" element={<NotFoundPage />} />
    </Routes>
);

export default Posts;
